import script from "./ErrorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorView.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorView.vue?vue&type=style&index=0&id=3525fc20&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3525fc20"]])

export default __exports__